import React, { useState, useCallback, useRef, useEffect } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
//api
import { createTypeSchedule } from 'api/company';
//components
import Title from 'components/backoffice/texts/title';
import TypeScheduleForm from 'components/backoffice/forms/typeScheduleForm';

const CreateTypeSchedules = () => {
  const { t } = useTranslation(['backoffice']);
  const [isCleanInputs, setIsCleanInputs] = useState(false)
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const { setTitle } = useOutletContext()

  useEffect(() => {
    setTitle(t('createtypeschedule'))
    return () => {
      setTitle('');
    };
  }, [setTitle])

  const handleClearFile = (icon) => {
    if (icon !== undefined) {
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  const defaultValues = {
    name: '',
    icon: undefined
  }

  const onSubmit = useCallback(async (values) => {
    const data = {
      name: values.name,
      icon: values.icon
    };
    try {
      const response = await createTypeSchedule(data);
      const { status, data: responseData } = response;
      if (responseData?.name?.[0] === "The type of schedule provided is already registered") {
        toast.error(t('typeScheduleAlreadyExists'), { theme: 'colored' });
        return;
      }
      if (status === 201) {
        toast.success(t('creadocorrectamente'));
        setIsCleanInputs(true);
        handleClearFile(values.icon);
        navigate('/intranet/type-schedules', { replace: true });
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  return (
    <>
      <Title text={t('createtypeschedule')} />
      <TypeScheduleForm
        isEditing={false}
        onSubmitForm={onSubmit}
        fileInputRef={fileInputRef}
        defaultValues={defaultValues}
        beforeTitle={t('createtypeschedule')}
      />
    </>
  );
};

export default CreateTypeSchedules;
